import "bootstrap/dist/css/bootstrap.min.css";
import { addLocale, FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { InputTextarea } from 'primereact/inputtextarea';
import React, { useEffect, useRef, useState } from 'react';
import Cookies from 'universal-cookie/es6';
import apis from '../../api';
import '../../DataTableDemo.css';
import useParamsLicense from '../../helpers/useParamsLicense';
import dateFormat from '../../services/DateFormat.service';
import invDateFormat from '../../services/InvertDateFormat.service';
import ConfBar from '../ConfBar/ConfBar';
import { LabelField } from './Banks.styles';
import { InputNumber } from 'primereact/inputnumber';
import Video from '../Video/Video';
import { tableDate, timeToDate } from "../../services/tableDate.service";
import SkeletonTable from "../SkeletonTable/SkeletonTable";
import { PickList } from "primereact/picklist";
import { set } from "lodash";
import './Banks.css'
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Licenses
Description : Tabla para la creación de ausentismos.
Date Autor Modification
================================================================================
27/10/2021 Santiago Coca Rojas Creación – Se implementa la tabla desde cero.
02/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente teniendo los cambios realizados con PrimeReact
================================================================================ */

export default function Banks() {

  /*Listas de valores del componente*/
  const [listaBancos, setListaBancos] = useState([]);
  const [listaTipoCuenta, setListaTipoCuenta] = useState([]);
  const [listaBancosDisp, setListaBancosDisp] = useState([]);

  /*Propiedades del componente*/
  const [banco, setBanco] = useState("");
  const [tipoCuenta, setTipoCuenta] = useState("");
  const [cuenta, setCuenta] = useState("");
  const [bancosConf, setBancosConf] = useState([]);
  const [idBanco, setIdBanco] = useState("");

  const [rowId, setRowId] = useState(0);

  /*Propiedades de los modales del componente*/
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpen_, setIsOpen_] = React.useState(false);
  const [isOpenEliminar, setIsOpenEliminar] = React.useState(false);
  const [isOpenH, setIsOpenH] = React.useState(false);

  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [loadPage, setLoadPage] = useState(false)
  const [listasCargadas, setListasCargadas] = useState(false)

  /*Constantes globales para el componente*/
  const headers = {
    authorization: localStorage.getItem('token')
  }

  /*Propiedades de la tabla del componente*/
  const [rowData, setRowData] = useState([]);
  const [rows, setRows] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(10);
  const [selectedRows, setSelectedRows] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');
  const elementWidth = { width: "20rem", justifySelf: "center" }

  const toast = useRef(null);

  /*Formato para el calendario del componente*/
  addLocale('es', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    today: 'Hoy',
    clear: 'Claro'
  });

  useEffect(() => {
    /*Se cargan los datos de las listas de valores y de la tabla del componente*/
    setTabla();
  }, []);


  /*Funciones que manejan el comportamiento de la tabla del componente*/
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }

  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por página: </span>
          <Dropdown className="sel" value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Agregar" icon="pi pi-plus" className="p-button-success mr-2 p-button-sm" onClick={() => showModal()} />
      </React.Fragment>
    )
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <div>
        <Button icon="pi pi-pencil" className="p-button-warning mr-2 p-button-sm text-xs" tooltip="Actualizar banco" tooltipOptions={{ position: 'top' }} onClick={() => { setIdBanco(rowData["ID"]); initializeData(rowData) }} />
        <Button icon="pi pi-trash" className="p-button-danger mr-2 p-button-sm text-xs" tooltip="Eliminar banco" tooltipOptions={{ position: 'top' }} onClick={() => { setIdBanco(rowData["ID"]); showModalEliminar() }} />
      </div>
    )
  }

  const renderHeader1 = () => {
    return (
      <div className="flex justify-content-between">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText className="p-inputtext-sm" value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" />
        </IconField>
      </div>
    )
  }

  const onGlobalFilterChange1 = (e) => {
    /*Filtro global de la tabla*/
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;

    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  const clearFilter1 = () => {
    initFilters1();
  }

  const initFilters1 = () => {
    /*Filtros de la tabla del componente*/
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'BANK': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'ACCOUNT_TYPE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'ACCOUNT_NUMBER': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'BANKS_DET': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    });
    setGlobalFilterValue1('');
  }

  const header1 = renderHeader1();

  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];

  /*Funciones que manejan el comportamiento de los modales del componente*/
  const showModal = () => {
    setListas()
    setIsOpen(true);
  };

  const hideModal = () => {
    setIsOpen(false);
    limpiar();
  };

  const showModal_ = () => {
    setListas()
    setIsOpen_(true);
  };

  const hideModal_ = () => {
    setIsOpen_(false)
    limpiar()
  };

  const showModalEliminar = () => {
    setIsOpenEliminar(true);
  };

  const hideModalEliminar = () => {
    setIsOpenEliminar(false)
  };

  const showModalH = () => {
    setIsOpenH(true);
  };

  const hideModalH = () => {
    setIsOpenH(false);
  };

  async function limpiar() {
    setIdBanco("");
    setBanco("");
    setBancosConf([]);
    setListaBancosDisp([])
    setTipoCuenta("");
    setCuenta("");
  }

  async function setListas() {
    await apis.getBankList(localStorage.getItem("entity"), localStorage.getItem("client"), headers).then(res => {
      let bancos = res.data["LOV_CODE_BANK"]
      let tipos = res.data["TIPO_CUENTA"]//Code, Name
      let bancosDisp = res.data["BANKS_DETAIL"]//Code, Name
      let _bancos = []
      bancosDisp.forEach(bank => {
        _bancos.push({
          ID: bank.detail_id,
          BANK: bank.description
        })
      })
      setListaBancos(bancos);
      setListaTipoCuenta(tipos);
      setListaBancosDisp(_bancos);
      setListasCargadas(true)
    })
  }

  async function setTabla() {
    /*Función encargada de cargar la información de la tabla del componente*/
    try {
      await apis.getBank(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
        console.log("saksmnalkdnsalk")
        if (res.data["BANKS"].length > 0) {
          let data = res.data["BANKS"]
          let contenidoTabla = []
          data.forEach(element => {
            console.log(element)
            let banco = element["BANK"].split("|")
            let tipoCuenta = element["ACCOUNT_TYPE"].split("|")
            contenidoTabla.push({
              ...element,
              BANK_ID: banco[0],
              BANK: banco[1],
              ACCOUNT_TYPE_ID: tipoCuenta[0],
              ACCOUNT_TYPE: tipoCuenta[1]
            })
          })
          setRowData(contenidoTabla)
          setRows(contenidoTabla)
          setLoadPage(true)
        }
        else {
          setRows([])
          setRowData([])
          setLoadPage(true)
        }
      })
    }
    catch (err) {
      setLoadPage(true)
    }
  }

  async function postBank() {

    /*Función ecargada de guardar el ausentismo en la base de datos */
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _tipoCuenta = tipoCuenta.detail_id;
    const _banco = banco.detail_id;
    const _cuenta = cuenta;
    const _bancosConf = bancosConf;

    let _bancos = []

    _bancosConf.forEach(bank => {
      _bancos.push({
        ID: bank.ID
      })
    })

    const banks = {
      CLIENT: _cliente,
      ENTITY: _entity,
      BANK: _banco,
      ACCOUNT_TYPE: _tipoCuenta,
      ACCOUNT_NUMBER: _cuenta,
      BANKS: _bancos
    }

    try {
      await apis.postBank(banks, headers).then(res => {
        setLoading1(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Banco agregado exitosamente' });
      })
      setTabla();
      limpiar();
      hideModal();
    } catch (err) {
      setLoading1(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function putBank() {

    /*Función encargada de actualizar el ausentismo en la base de datos*/
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _tipoCuenta = tipoCuenta.detail_id;
    const _banco = banco.detail_id;
    const _cuenta = cuenta;
    const _bancosConf = bancosConf;
    const _idBanco = idBanco

    let _bancos = []

    _bancosConf.forEach(bank => {
      _bancos.push({
        ID: bank.ID
      })
    })

    const banks = {
      ID: _idBanco,
      CLIENT: _cliente,
      ENTITY: _entity,
      BANK: _banco,
      ACCOUNT_TYPE: _tipoCuenta,
      ACCOUNT_NUMBER: _cuenta,
      BANKS_DET: _bancos
    }

    try {
      await apis.putBank(banks, headers).then(res => {
        setLoading2(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Banco actualizado exitosamente' });
      })
      setTabla();
      limpiar();
      hideModal_();
    } catch (err) {
      setLoading2(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function deleteBank() {

    /*Función encargada de eliminar el ausentismo en la base de datos */
    const _cliente = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity')
    const _banco = idBanco

    try {
      await apis.deleteBank(_entity, _cliente, _banco, headers).then(res => {
        setLoading3(false)
        toast.current.show({ severity: 'info', summary: 'Info', detail: 'Banco eliminado exitosamente' });
      })
      setTabla();
      hideModalEliminar();
      limpiar();
    } catch (err) {
      setLoading3(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  function initializeData(rowData) {
    /*Función encargada de inicializar las propiedades del componente con los valores de el ausentismo seleccionado*/
    console.log(rowData)
    setIdBanco(rowData.ID)
    setBanco({
      ...banco,
      detail_id: rowData.BANK_ID,
      description: rowData.BANK
    })
    setTipoCuenta({
      ...tipoCuenta,
      detail_id: rowData.ACCOUNT_TYPE_ID,
      description: rowData.ACCOUNT_TYPE
    })
    setCuenta(rowData.ACCOUNT_NUMBER)
    setBancosConf(rowData.BANKS_DET);
    showModal_();
  }

  /*Headers y footers de los modales del componente*/
  const addFooter = (
    <div>
      <Button onClick={() => { setLoading1(false); hideModal() }}>Cancelar</Button>
      <Button label="Guardar" loading={loading1} onClick={() => { setLoading1(true); postBank() }}
        disabled={!cuenta || !tipoCuenta || !banco || bancosConf.length === 0} />
    </div>
  );

  const addHeader = (
    <div>
      <h3>Agregar banco</h3>
    </div>
  )

  const updateFooter = (
    <div>
      <Button onClick={() => { setLoading2(false); hideModal_() }}>Cancelar</Button>
      <Button label="Guardar" loading={loading2} onClick={() => { setLoading2(true); putBank() }} />
    </div>
  );

  const updateHeader = (
    <div>
      <h3>Actualizar banco</h3>
    </div>
  )

  const deleteFooter = (
    <div>
      <Button onClick={() => { setLoading3(false); hideModalEliminar() }}>Cancelar</Button>
      <Button label="Si" loading={loading3} onClick={() => { setLoading3(true); deleteBank() }} />
    </div>
  );

  const deleteHeader = (
    <div>
      <h3>¿Desea eliminar el banco?</h3>
    </div>
  )

  const footerHS = (
    <div>
      <Button label='Generar' loading={loading4} onClick={() => { setLoading4(true) }} />
    </div>
  );

  const headerHS = (
    <div>
      <h3>Parámetros reporte histórico de ausentismos</h3>
    </div>
  )

  /*Funciones que manejan el cambio en los campos de entrada del modal de gneración del reporte*/

  const banksTemplate = (rowData) => {
    return (
      <div>
        <Dropdown placeholder="Bancos asociados" options={rowData.BANKS_DET} optionLabel="BANK" />
      </div>
    )
  }

  const endDateTemplate = (rowData) => {
    const date = timeToDate(rowData.END_DATE);
    return date
  }

  const onMoveToTarget = (event) => {
    console.log(event.value)
    let difference = listaBancosDisp.filter(x => !event.value.includes(x));
    setListaBancosDisp(difference)
    setBancosConf([...bancosConf, ...event.value]);
  };

  const onMoveToSource = (event) => {
    console.log(event.value)
    let difference = bancosConf.filter(x => !event.value.includes(x));
    setBancosConf(difference)
    setListaBancosDisp([...listaBancosDisp, ...event.value]);
  }

  const onMoveAllToTarget = (event) => {
    console.log(event)
    setBancosConf([...bancosConf, ...event.value])
    setListaBancosDisp([])
  }

  const onMoveAllToSource = (event) => {
    console.log(event)
    setListaBancosDisp([...event.value, ...listaBancosDisp])
    setBancosConf([])
  }

  const itemTemplate = (item) => {
    return (
      <span className="font-bold">{item.BANK}</span>
    );
  };


  /*Renderizado del componente*/
  return (
    <div>
      <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">
        <Toast ref={toast} />
        <Dialog header={addHeader} footer={addFooter} visible={isOpen} style={{ width: "55vw" }}
          position="top" draggable={false} resizable={false} modal onHide={hideModal}>
          <div className="flex flex-row">
            <div>
              <LabelField htmlFor="label">Banco</LabelField>
              <Dropdown filter filterBy="description" style={elementWidth} value={banco} options={listaBancos} placeholder={"Seleccione un banco"}
                onChange={(e) => { setBanco(e.value) }} optionLabel="description" />
            </div>
            <div>
              <LabelField htmlFor="label">Tipo cuenta</LabelField>
              <Dropdown style={elementWidth} value={tipoCuenta}
                filter filterBy="description" emptyMessage={"No hay tipos disponibles"}
                options={listaTipoCuenta} placeholder={"Seleccione tipo"}
                onChange={(e) => {
                  setTipoCuenta(e.value)
                }}
                optionLabel="description"
              />
            </div>
          </div>
          <div>
            <LabelField htmlFor="label">Nro cuenta</LabelField>
            <InputText
              style={elementWidth}
              id="label2"
              type="number"
              value={cuenta}
              placeholder="Cuenta"
              onChange={(e) => setCuenta(e.target.value)}
            />
          </div>
          <LabelField htmlFor="label">Bancos a pagar</LabelField>
          <div className="card">
            <PickList dataKey="ID" source={listaBancosDisp} target={bancosConf} onMoveToTarget={onMoveToTarget} onMoveToSource={onMoveToSource}
              onMoveAllToTarget={onMoveAllToTarget} onMoveAllToSource={onMoveAllToSource} itemTemplate={itemTemplate} breakpoint="1280px"
              sourceHeader="Bancos" targetHeader="Bancos a pagar" sourceStyle={{ height: '24rem' }} targetStyle={{ height: '24rem' }}
              showSourceControls={false} showTargetControls={false}
            />
          </div>
        </Dialog>
        <Dialog header={updateHeader} footer={updateFooter} visible={isOpen_} style={{ width: "55vw" }}
          position="top" draggable={false} resizable={false} modal onHide={hideModal_}>
          <div className="flex flex-row">
            <div>
              <LabelField htmlFor="label">Banco</LabelField>
              <Dropdown filter filterBy="description" style={elementWidth} value={banco} options={listaBancos} placeholder={"Seleccione un banco"}
                onChange={(e) => { setBanco(e.value) }} optionLabel="description" />
            </div>
            <div>
              <LabelField htmlFor="label">Tipo cuenta</LabelField>
              <Dropdown style={elementWidth} value={tipoCuenta}
                filter filterBy="description" emptyMessage={"No hay tipos disponibles"}
                options={listaTipoCuenta} placeholder={"Seleccione tipo"}
                onChange={(e) => {
                  setTipoCuenta(e.value)
                }}
                optionLabel="description"
              />
            </div>
          </div>
          <div>
            <LabelField htmlFor="label">Nro cuenta</LabelField>
            <InputText
              style={elementWidth}
              id="label2"
              value={cuenta}
              type="number"
              placeholder="Cuenta"
              onChange={(e) => setCuenta(e.target.value)}
            />
          </div>
          <LabelField htmlFor="label">Bancos a pagar</LabelField>
          <div className="card">
            <PickList dataKey="ID" source={listaBancosDisp} target={bancosConf} onMoveToTarget={onMoveToTarget} onMoveToSource={onMoveToSource}
              onMoveAllToTarget={onMoveAllToTarget} onMoveAllToSource={onMoveAllToSource} itemTemplate={itemTemplate} breakpoint="1280px"
              sourceHeader="Bancos" targetHeader="Bancos a pagar" sourceStyle={{ height: '24rem' }} targetStyle={{ height: '24rem' }}
              showSourceControls={false} showTargetControls={false}
            />
          </div>
        </Dialog>
        <Dialog header={deleteHeader} footer={deleteFooter} visible={isOpenEliminar}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalEliminar}>
        </Dialog>
        <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-2">
          <span className="text-900">Bancos</span>
          {/* <Video header="Instructivo proceso novedades" url={localStorage.getItem('NOVELTIESLICENSES_VIDEO')} /> */}
        </div>
        <div className="card mt-4">
          <SkeletonTable load={loadPage}>
            <Toolbar className="mb-4" start={leftToolbarTemplate}></Toolbar>
            <DataTable className="text-xs" value={rows} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
              selection={selectedRows} onSelectionChange={(e) => setSelectedRows(e.value)} dataKey="ID"
              size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['CONTRACT_ID', 'NUMBER_ID', 'NAME', 'CONCEPT', 'UNIT', 'CALENDAR', 'EXTENSION']}
              header={header1} >
              <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
              <Column field="ID" header="ID" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column>
              <Column field="BANK" header="Banco" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Identificación" sortable></Column>
              <Column field="ACCOUNT_TYPE" header="Tipo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
              <Column field="ACCOUNT_NUMBER" header="Cuenta" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
              <Column field="BANKS_DET" header="Bancos" body={banksTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha inicio" sortable></Column>
              <Column header="Acciones" headerStyle={{ width: '8rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
            </DataTable>
          </SkeletonTable>
        </div>
      </div>
    </div>
  );
}